import { BrowseViewResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { PostOffice } from '@/common';
import env from '@/env';

export const getPostOFfice = async ({
  page,
  pageSize,
  search,
}: {
  page: number;
  pageSize: number;
  search: string;
}): Promise<BrowseViewResponseDto<PostOffice>> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/post-office?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
    })}`,
    { method: 'GET' }
  );

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<PostOffice>;
  return response;
};
